import { createMuiTheme } from '@material-ui/core';

import { newTheme } from 'app/styles/themes/newTheme';

export const createDefaultTheme = () => createMuiTheme(newTheme);
